<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('logs_list_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            color="primary"
                            class="white--text"
                            @click="showForm()"
                    >
                        {{$t('create')}}
                        <v-icon right dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('logs_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table  class="text-capitalize" :headers="headers" :items="items" :loading="loading">
                    <template #item.name="{item}">
                        {{item.name}}
                        <v-chip x-small color="success" v-if="item.user_selectable">قابل فروش</v-chip>
                        <v-chip x-small color="info" v-else>غیره قابل فروش</v-chip>
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.validity_duration="{item}">
                        {{$t('validity_duration_options')[item.validity_duration] || item.validity_duration}}
                    </template>
                    <template #item.price="{item}">
                        <span v-if="item.price">
                            {{$t('display_price', { price : $n(item.price) })}}
                        </span>
                        <v-chip
                                v-else
                                color="success"
                                small
                        >{{$t('free')}}</v-chip>
                    </template>
                    <template #item.tax_rate="{item}">
                        <span v-if="item.tax_rate">
                            {{item.tax_rate}}
                        </span>
                        <v-chip
                                v-else
                                color="success"
                                small
                        >{{$t('no_tax')}}</v-chip>
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip
                                top
                                color="primary"
                                content-class="caption iransans px-3"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-btn
                                        v-on="on"
                                        color="grey"
                                        fab
                                        x-small
                                        text
                                        @click="showForm(item)"
                                >
                                    <v-icon>mdi-pen</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('edit')}}</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{ name: 'SubscriptionList', query: { filters: [{ value: item.id, operand: 'IsEqualTo', column_name : 'subscription_class_id' }], orders: [{ 'column_name' : 'id', 'value' : 'desc' }] } }"
                                        class="no-decoration"
                                >
                                    <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                    >mdi-cube-send</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('subscriptions')}}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <Form
                v-if="item"
                :item="item"
                @close="item = null"
                @submit="fetch"
        />
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/SubscriptionClassesService";
    import Form from "../components/SubscriptionClassForm";

    import config from "@/config";
    export default {
        components : {
            Form
        },
        created() {
            this.fetch();
        },
        watch: {
            dialog (val) {
                !val && this.close()
            }
        },
        data() {
            return {
                logsSeen : {},
                dialog : false,
                loading : false,
                logDetails : null,
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('name'),
                        value: 'name',
                    },
                    {
                        text: this.$t('validity_duration'),
                        value: 'validity_duration',
                    },
                    {
                        text: this.$t('limitation_send_table'),
                        value: 'limitation_send',
                    },
                    {
                        text: this.$t('price'),
                        value: 'price',
                    },
                    {
                        text: this.$t('tax_rate'),
                        value: 'tax_rate',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                items : [],
                item : null,
                total : 0,
                page : 1,
                fetchCount : config.fetchCount
            }
        },
        methods: {
            async fetch() {
                this.loading = true;
                let requestList = new RequestList();
                requestList.setFilters(this.$route.query.filters || [])
                requestList.addOrder('id','desc');
                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.subscription_classes;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            }

        }
    }
</script>